import { HttpClient } from "@angular/common/http";
import { inject, Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { SocietyInvoiceMasterCreateRequestDTO, SocietyInvoiceMasterDeleteRequestDTO, SocietyInvoiceMasterDTO, SocietyInvoiceMasterList, SocietyInvoiceMasterReadByIdRequestDTO, SocietyInvoiceMasterUpdateRequestDTO } from "./invoice-master.interface";
import { SocietyInvoiceMaster_Create, SocietyInvoiceMaster_Delete, SocietyInvoiceMaster_ReadAll, SocietyInvoiceMaster_ReadById, SocietyInvoiceMaster_Update } from "src/app/GlobalVariable";

@Injectable({
  providedIn: 'root',
})
export class SM_SocietyInvoiceMasterService {
 

  constructor() { }

  http = inject(HttpClient);


  SocietyInvoiceMaster_Create(data: SocietyInvoiceMasterCreateRequestDTO): Observable<SocietyInvoiceMasterDTO>{
    return this.http.post<SocietyInvoiceMasterDTO>(SocietyInvoiceMaster_Create,data)
  }

 SocietyInvoiceMaster_Update(data: SocietyInvoiceMasterUpdateRequestDTO):Observable<SocietyInvoiceMasterDTO>{
    return this.http.post<SocietyInvoiceMasterDTO>(SocietyInvoiceMaster_Update,data)
 }

 SocietyInvoiceMaster_Delete(data: SocietyInvoiceMasterDeleteRequestDTO): Observable<void>{
    return this.http.post<void>(SocietyInvoiceMaster_Delete,data);
 }

 SocietyInvoiceMaster_ReadAll(): Observable<SocietyInvoiceMasterList> {
    return this.http.get<SocietyInvoiceMasterList>(SocietyInvoiceMaster_ReadAll);
 }

 SocietyInvoiceMaster_ReadById(data: SocietyInvoiceMasterReadByIdRequestDTO ) {
    return this.http.post<SocietyInvoiceMasterDTO> (SocietyInvoiceMaster_ReadById,data)
 }

}